(function () {
  'use strict';

  function setScrolledState() {
    document.body.classList.toggle('htl-scrolled', window.scrollY > 16);
  }

  function makeCardsKeyboardFriendly() {
    document.querySelectorAll('.product-grid-item .products').forEach(function (card) {
      card.addEventListener('focusin', function () {
        card.classList.add('is-focused');
      });
      card.addEventListener('focusout', function (event) {
        if (!card.contains(event.relatedTarget)) card.classList.remove('is-focused');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setScrolledState();
    makeCardsKeyboardFriendly();
  });

  document.addEventListener('shopify:section:load', makeCardsKeyboardFriendly);
  window.addEventListener('scroll', setScrolledState, { passive: true });
})();
